import React, { useEffect, useState } from "react";
import { Button } from "../../../components/ui";
import { TMarketHolidays } from "../../../types/markets";
import moment from "moment";
import NodataAvailable from "../../../assets/images/NodataAvailable.svg";

interface Event {
  date: string;
  event: string;
  eventType?: string;
}

interface MonthData {
  name: string;
  count: number;
  events: Event[];
}

interface MarketMonthsDataProps {
  data: TMarketHolidays[];
}

const MarketMonthsData: React.FC<MarketMonthsDataProps> = ({ data }) => {
  const [monthsData, setMonthsData] = useState<MonthData[]>([]);
  const [activeMonth, setActiveMonth] = useState<string>("");

  useEffect(() => {
    if (!data || data.length === 0) {
      setMonthsData([]);
      return;
    }

    const grouped = data.reduce<Record<string, Event[]>>((acc, item) => {
      const month = item.month;
      if (!acc[month]) acc[month] = [];

      acc[month].push({
        date: moment(item.date).format("DD-MMM-YYYY"),
        event: item.eventName,
        eventType: item.eventType,
      });

      return acc;
    }, {});

    const monthOrder = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const structured: MonthData[] = Object.keys(grouped)
      .sort((a, b) => monthOrder.indexOf(a) - monthOrder.indexOf(b))
      .map((month) => ({
        name: month,
        count: grouped[month].length,
        events: grouped[month],
      }));

    setMonthsData(structured);
    if (structured.length > 0) setActiveMonth(structured[0].name);
  }, [data]);

  const activeMonthData = monthsData.find((m) => m.name === activeMonth);

  return (
    <div>
      <div
        className={`flex gap-2 overflow-x-auto  sticky top-0 bg-white z-10 ${
          activeMonthData ? "p-3" : ""
        }`}
        id="scroll_style"
      >
        {monthsData.map((month) => (
          <button
            key={month.name}
            onClick={() => setActiveMonth(month.name)}
            className={`px-4 py-1 text-sm font-semibold whitespace-nowrap transition-all ${
              activeMonth === month.name
                ? "color-primary bg-[#EBFFF0] border-primary"
                : "bg-gray-bg color-text-primary hover:bg-gray-bg"
            }`}
            style={{ borderRadius: "20px" }}
          >
            {month.name} ({month.count})
          </button>
        ))}
      </div>

      {activeMonthData ? (
        <div className="overflow-hidden">
          <div className="bg-[#F4F4F4] text-center py-2 font-semibold text-sm color-text-primary border-b border-t">
            {activeMonthData.name}
          </div>

          {activeMonthData.events.map((event, index) => (
            <div
              key={index}
              className="flex justify-between items-center px-4 py-3 border-b last:border-b-0"
            >
              <div className="flex-1">
                <p className="color-sub-text text-xs">Date</p>
                <p className="font-semibold text-sm color-text-primary">
                  {event.date}
                </p>
              </div>
              <div className="flex-1 flex flex-col justify-center">
                <p className="color-sub-text text-xs">Event</p>
                <p className="font-semibold text-sm color-text-primary">
                  {event.event}
                </p>
              </div>
              <div className="flex-1">
                {event.eventType && (
                  <span className="flex items-center color-red text-xs font-medium gap-1">
                    ⚠️ {event.eventType}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex items-center justify-center w-full h-full p-3">
          <img
            src={NodataAvailable}
            alt="No data available"
            className="w-[110px]"
          />
        </div>
      )}

      {/* <div className="flex border-t">
        <div className="p-3">
          <Button
            variant="outlined-primary"
            text="See All"
            onClick={() => {}}
          />
        </div>
      </div> */}
    </div>
  );
};

export default MarketMonthsData;
